import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
var NAMESPACE = 'SAGA.API.CMS';
var SPACES = {
  legal: 'legal',
  webContent: 'consumer_web_content',
  webData: 'consumer_web_data',
  webPage: 'consumer_web'
};
var pathMapping = [{
  path: '/',
  contentfulPath: '/homepage'
}, {
  path: /^(\/invite).*/,
  contentfulPath: '/invite'
}];

var getPathMapping = function getPathMapping(path) {
  var pathMap = pathMapping.find(function (mapping) {
    return mapping.path.test ? mapping.path.test(path) : mapping.path === path;
  });
  return pathMap && pathMap.contentfulPath || path;
};

export var cms = makeEntityScaffold(NAMESPACE, function (client, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.cms.getContentBySpace(SPACES.webPage, _objectSpread({
    path: getPathMapping(path)
  }, options)).then(function (_ref) {
    var content = _ref.content;
    return content;
  });
}, {
  defaultKey: function defaultKey(client, path) {
    return getPathMapping(path);
  }
});
export var cmsLegalContent = makeEntityScaffold("".concat(NAMESPACE, ".LEGAL_CONTENT"), function (client, path) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    transformToHTML: false
  };
  return client.cms.getContentBySpace(SPACES.legal, {
    path: path,
    transformToHTML: config.transformToHTML
  }).then(function (_ref2) {
    var content = _ref2.content;
    return content.data;
  });
}, {
  defaultKey: function defaultKey(client, path) {
    return path;
  }
});
export var cmsWebContent = makeEntityScaffold("".concat(NAMESPACE, ".WEB_CONTENT"), function (client, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.cms.getContentBySpace(SPACES.webContent, _objectSpread({
    path: path
  }, options)).then(function (_ref3) {
    var content = _ref3.content;
    return content;
  });
}, {
  defaultKey: function defaultKey(client, path) {
    return path;
  }
});
export var cmsWebData = makeEntityScaffold("".concat(NAMESPACE, ".WEB_DATA"), function (client, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.cms.getContentBySpace(SPACES.webData, _objectSpread({
    path: path
  }, options)).then(function (_ref4) {
    var content = _ref4.content;
    return content;
  });
}, {
  defaultKey: function defaultKey(client, path) {
    return path;
  }
});